import DailyImage from "../components/DailyImage/DailyImage";

export default function DailyImagePage() {
	return <DailyImage />;
}
